/**
 * What the pre-render leaves in the HTML for the client to find. Shared by the build step
 * (`prerender/html.ts`, which writes them) and the browser entry (`app/boot.tsx`, which reads them),
 * so it stays dependency-free: it is part of the first load.
 */

/** `id` of the inert `<script type="application/json">` that carries the dehydrated query cache. */
export const STATE_SCRIPT_ID = 'sbg-state';

/**
 * Attribute on `#root` naming the address the markup was rendered for (`/shop/tan-brown-granite-slab`). The
 * client hydrates only when it is on that very page; for any other address (the single-page-app
 * shell served for a route that was not pre-rendered, a page with a search string …) it renders
 * afresh instead of mismatching.
 */
export const PRERENDER_ATTRIBUTE = 'data-prerender';

/** Value of {@link PRERENDER_ATTRIBUTE} on the 404 pages: they are never hydrated, the client renders the router's answer. */
export const NOT_FOUND_MARKER = '*';

/**
 * Comments around the head tags React hoisted out of the page (`<title>`, canonical, Open Graph …).
 * A hydrating client adopts those tags as its own; a client that renders afresh (see
 * {@link PRERENDER_ATTRIBUTE}) removes them first, or React would add a second set beside them.
 */
export const HEAD_START = 'sbg-head';
export const HEAD_END = '/sbg-head';

/**
 * `id` of the inert `<template>` in `<head>` that holds the `<link rel="modulepreload">` tags of a pre-rendered
 * page. They are not live in the HTML — a preload that starts while the HTML, the CSS and the hero image are still
 * arriving would share a slow link with them — and `main.tsx` activates them (`startPreloads`) when it boots the app,
 * after the first paint.
 */
export const BOOT_PRELOAD_ID = 'sbg-boot-preload';
